import { ReactElement, useState } from 'react';
import { AccordionItemHeaderProps } from './AccordionItemHeader';
import React from 'react';
import { FCWW } from 'types';

export interface AccordionItemProps {
  children: [ReactElement<AccordionItemHeaderProps>, React.ReactNode];
}

export const AccordionItem: FCWW<AccordionItemProps> = ({ children }) => {
  const [unfolded, setUnfolded] = useState(false);

  const toggleUnfolded = () => {
    setUnfolded((unfolded) => !unfolded);
  };

  return (
    <div className="accordion-item">
      {React.cloneElement(children[0], { unfolded, toggleUnfolded })}
      {unfolded && children[1]}
    </div>
  );
};
